// Custom DOM events to be used for tricky situations in which
// declarative reactivity is sub-optimal. For example, focusing a text
// field in one component based on actions in another where there is no
// clean connection between the two. Use sparingly.
// @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent

export function takeNotesForMeEvent( detail = {} ) {
	return new CustomEvent( "takeNotesForMeEvent", { detail, } );
}
